import FirebaseContext from 'contexts/FirebaseContext';
import { Container } from '@mui/material';
import { Component } from 'react';
import { safeReload } from './utils/safeReload';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  
  componentDidMount() {
    this.setState({ currentUrl: window.location.href });
    
    // Handle Vite preload errors (e.g., when assets are deleted after new deployment)
    this.handleVitePreloadError = (event) => {
      console.warn('Vite preload error detected:', event.payload);
      // Prevent the error from being thrown
      event.preventDefault();
      // Reload the page to fetch the new assets (guarded against reload loops)
      safeReload();
    };
    
    window.addEventListener('vite:preloadError', this.handleVitePreloadError);
  }
  
  componentWillUnmount() {
    // Clean up the event listener
    if (this.handleVitePreloadError) {
      window.removeEventListener('vite:preloadError', this.handleVitePreloadError);
    }
  }
  
  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
    const errorWithInfo = `${error.toString()} ${window.location.href} ${error.stack} ${
      errorInfo.componentStack
    }`;
    this.setState({ hasError: true, errorText: errorWithInfo.substring(0, 600) });
  }
  
  render() {
    if (this.state.hasError) {
      const isChunkLoadError = this.state.errorText.includes('ChunkLoadError');
      return (
        <FirebaseContext.Consumer>
          {(firebase) => {
            // Now you have access to firebase object
            // You can use it to report the error
            const reportError = async (error) => {
              try {
                const reportErrorFunction = firebase.functions.httpsCallable('reportError');
                const response = await reportErrorFunction({ error: error });
                return response.data;
              } catch (error) {
                console.error('Error reporting error:', error);
              }
            };
            reportError(this.state.errorText);
            return (
              <Container>
                <h2>Dang. Something went wrong.</h2>
                {isChunkLoadError && (
                  <p>
                    It looks like you need to refresh your browser since a recent program update.
                    Note that you may have more than one tab open still running the old version.
                    Close them all out and refresh!
                  </p>
                )}
                {!isChunkLoadError && (
                  <>
                    <p>
                      The error has been logged, if you have a moment please notify a developer with
                      a brief description of what you were doing when the error occurred.
                    </p>
                    <p>
                      <code>{this.state.errorText}</code>
                    </p>
                    <code>{this.state.currentUrl}</code>
                  </>
                )}
              </Container>
            );
          }}
        </FirebaseContext.Consumer>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;